import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { saveAs } from 'file-saver';

@Injectable()
export class PgsOrderService {
  pgsOrderHeaderId: BehaviorSubject<number>;
  confirmationPgsOrderId: BehaviorSubject<number>;
  redirectFrom: BehaviorSubject<any>;
  constructor(
    private configService: ConfigService,
    private networkService: NetworkService
  ) {
    this.pgsOrderHeaderId = new BehaviorSubject(0);
    this.confirmationPgsOrderId = new BehaviorSubject(0);
    this.redirectFrom = new BehaviorSubject<any>(null);
  }

  public setPgsOrderHeaderId(value: number) {
    this.pgsOrderHeaderId.next(value);
  }

  public getProductLines() {
    return this.networkService.getRequest(this.configService.getPgsOrderProductLines());
  }

  public getLandingData(filter: any) {
    return this.networkService.postRequest(this.configService.getPgsOrderLandingData(), filter);
  }

  public getPackDetails(pgsPackConfigHeaderId: number) {
    return this.networkService.getRequest(`${this.configService.getPgsPackDetails()}?pgsPackConfigHeaderId=${pgsPackConfigHeaderId}`);
  }

  public exportToExcel(filter: any) {
    return this.networkService.postRequest(this.configService.getPgsOrderExportData(), filter);
  }

  public setConfirmationPgsOrderId(value: number) {
    this.confirmationPgsOrderId.next(value);
  }
  public setRedirectionFrom(value: any) {
    if (!this.redirectFrom) {
      this.redirectFrom = new BehaviorSubject<any>(value);
    } else {
      this.redirectFrom.next(value);
    }
  }
  public checkCreateAccess() {
    return this.networkService.getRequest(this.configService.checkCreateAccessForPgs());
  }

  public getOrderSummaryData(orderHeaderId) {
    return this.networkService.getRequest(this.configService.getPgsOrderSummaryData() + '?orderHeaderId=' + orderHeaderId);
  }

  public getPgsOrderSummaryData(orderHeaderId) {
    return this.networkService.getRequest(this.configService.getPgsOrderSummaryData() + '?orderHeaderId=' + orderHeaderId);
  }

  public getPgsEditOrderDetail(orderHeaderId) {
    return this.networkService.getRequest(this.configService.getPgsEditOrderDetail() + '?orderHeaderId=' + orderHeaderId);
  }

  public getCreateOrderHeaderData() {
    return this.networkService.getRequest(this.configService.getPgsCreateOrderHeaderData());
  }

  public getDeliverTo(accountNumber, parentAccountNumber) {
    return this.networkService.getRequest(this.configService.getPgsDeliverTo() + '?accountNumber=' + accountNumber + '&parentAccountNumber=' + parentAccountNumber);
  }

  public getOrderDetailsData(filter) {
    return this.networkService.postRequest(this.configService.getPgsOrderDetailsData(), filter);
  }

  public placeOrder(order) {
    return this.networkService.postRequest(this.configService.placePgsOrder(), order);
  }
  
  public checkExistingOrder(salesManager, shipToaccount, productLine) {
    return this.networkService.getRequest(this.configService.checkPgsExistingOrder() + '?salesManagerAccount=' + salesManager + '&shipToAccount=' + shipToaccount + '&productLineId=' + productLine);
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
  }

  base64toFile(base64String, contentType, fileName) {
    const blob = this.b64toBlob(base64String, contentType, 550);
    saveAs(blob, fileName);
  }
}
